import { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { useFetchItensByProcesso } from '@hooks/api/ItensProcesso/useFetchItensByProcesso.js';
import { StyledTableItensProcessoSolicitacao } from '@styles/datatables/datatable-itens-processo-solicitacao.js';
import ptBR from 'antd/es/locale/pt_BR';
import { Spinner } from '@styles/loading.js';
import TextBlock from '@components/UI/TextBlock/Index..jsx';

const GridItensProcessoSolicitacao = ({
  idProcesso,
  etapaProcesso,
  onSelectItensProcesso,
}) => {
  const [tableData, setTableData] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const {
    fetchItensByProcesso,
    itensProcessoOptions,
    itensProcessoLoading,
    totalItens,
    currentPage,
    rowsPerPage,
    setCurrentPage,
    setRowsPerPage,
  } = useFetchItensByProcesso();

  useEffect(() => {
    if (itensProcessoOptions) {
      setTableData(itensProcessoOptions.map((item) => ({ ...item })));
    }
  }, [itensProcessoOptions]);

  useEffect(() => {
    if (idProcesso && etapaProcesso) {
      fetchItensByProcesso(idProcesso, etapaProcesso, currentPage, rowsPerPage);
    } else {
      setTableData([]);
      setSelectedRowIds([]);
    }
  }, [idProcesso, etapaProcesso, currentPage, rowsPerPage]);

  const syncParentData = (localData, selectedIds) => {
    const finalData = localData.map((row) => ({
      idProcessoItem: row.id,
      codigoProcessoItem: row.codigo,
      flagSelecionado: selectedIds.includes(row.id),
    }));
    onSelectItensProcesso(selectedIds.length === 0 ? [] : finalData);
  };

  const onRowSelectionChange = (selectedKeys) => {
    setSelectedRowIds(selectedKeys);
    syncParentData(tableData, selectedKeys);
  };

  const columns = [
    {
      title: 'Item do Processo',
      dataIndex: 'nomeItem',
      key: 'nomeItem',
      width: '90%',
      sorter: (a, b) => a.nomeItem.localeCompare(b.nomeItem),
      render: (text) => <TextBlock>{text}</TextBlock>,
    },
  ];

  const rowSelection = {
    columnTitle: '-',
    selectedRowKeys: selectedRowIds,
    onChange: onRowSelectionChange,
  };

  const dataSource = tableData.map(item => ({ ...item, key: item.id }));
  const selectedCount = selectedRowIds.length;

  return (
    <div className="px-3">
      <div className="py-3">
        <h3>
          Após realizar a associação do Compliace à Solicitação,
          aqui serão exibidos os itens do processo.
        </h3>
      </div>

      <div className="text-start">
        <h1>
          <strong>{selectedCount}</strong>{' '}
          {selectedCount === 1 ? 'item selecionado' : 'itens selecionados'}
        </h1>
      </div>

      {itensProcessoOptions === null ? (
        <h2 className="m-3">Nenhum processo foi associado ainda.</h2>
      ) : (
        <div className='mt-4'>
          <ConfigProvider locale={ptBR}>
            <StyledTableItensProcessoSolicitacao
              columns={columns}
              dataSource={dataSource}
              pagination={{
                current: currentPage,
                pageSize: rowsPerPage,
                total: totalItens,
                onChange: setCurrentPage,
                onShowSizeChange: (current, size) => {
                  setRowsPerPage(size);
                  setCurrentPage(1);
                },
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }}
              scroll={dataSource.length > 0 ? { y: 300, x: 'max-content' } : undefined}
              loading={{ spinning: itensProcessoLoading, indicator: <Spinner /> }}
              rowSelection={rowSelection}
              locale={{
                emptyText: <h2 className="m-3"> Nenhum item do processo disponível no momento. </h2>
              }}
            />
          </ConfigProvider>
        </div>
      )}
    </div>
  );
};

export default GridItensProcessoSolicitacao;